import { ComponentProps, type FC } from 'react';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { Logo, useTheme } from '..';

export const PoweredByCurewikiLogo: FC<ComponentProps<'div'>> = (props) => {
  const { t } = useTranslation();
  const { bgColor } = useTheme();
  return (
    <div className={cx('flex gap-0 items-end', props.className)}>
      <div className="flex gap-2 items-center">
        <div className="text-black leading-none">{t('common.powered_by')}:</div>
        <Logo className="h-10 block w-auto text-black" />
      </div>
      <span
        className="text-[7px] leading-none text-base-100 rounded-lg px-1 py-[1px] w-fit"
        style={{ backgroundColor: bgColor }}
      >
        {t('common.beta')}
      </span>
    </div>
  );
};
